<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: whaoo
 * @Date: 2023-10-10 09:26:28
 * @LastEditors: whaoo
 * @LastEditTime: 2023-10-10 11:43:27
-->
<template>
  <div class="bed_box">
    <div @click="bedDetail(index+300)" class="bed" v-for="(item, index) in bed_list" :key="index">
      <div>{{ index + 300 }}床</div>
      <div>xxx 女 33岁</div>
      <!-- <div>ccid:1234567890192948481</div> -->
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bed_list: new Array(30)
    };
  },

  mounted() { },

  methods: {
    bedDetail(bednum){
      this.$router.push({
        path:"/bedDetail",
        query:{
          bed:bednum
        }
      })
    }
  }
}

</script>
<style  scoped>
.bed_box {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
}
.bed {
  width: 18%;
  margin-bottom: 20px;
  text-align: center;
  padding: 20px;
  box-sizing: border-box;
  border: 1px solid red;
}
</style>


// WEBPACK FOOTER //
// src/view/bed_list.vue